import { z } from 'zod';

import { TemplatesType } from '@gbs-monorepo-packages/common';

import {
  VALIDATION_LIMITS,
  VALIDATION_MESSAGES,
} from '../constants/ValidationRules';

const fromScratch = TemplatesType.BUILD_SCRATCH;

export const insertPageSchema = z
  .object({
    title: z.string().trim().min(1, { message: 'Page title is required' }),
    templateId: z.string().max(VALIDATION_LIMITS.COURSE.TITLE_MAX).optional(),
    templateOptionsId: z.number(),
  })
  .refine(
    (data) => {
      if (data.templateOptionsId === (fromScratch as number)) {
        return true;
      }
      return !!data.templateId?.trim();
    },
    {
      message: 'Please select a template',
      path: ['templateId'],
    }
  );

export const renamePageSchema = z.object({
  newTitle: z
    .string()
    .trim()
    .min(1, { message: 'New title is required' })
    .max(VALIDATION_LIMITS.COURSE.TITLE_MAX, {
      message: VALIDATION_MESSAGES.maxChars(VALIDATION_LIMITS.COURSE.TITLE_MAX),
    }),
});

export const restorePageSchema = z.object({
  version: z.number().min(1, { message: 'Please select a version to restore' }),
});

export const multipleDeleteSchema = z.object({
  pages: z
    .array(z.number())
    .min(1, { message: 'Please select at least one page to delete' }),
  selectedAll: z.boolean().default(false),
});

export type InsertPageSchema = z.infer<typeof insertPageSchema>;

export type RenamePageSchema = z.infer<typeof renamePageSchema>;

export type RestorePageSchema = z.infer<typeof restorePageSchema>;

export type MultipleDeleteSchema = z.infer<typeof multipleDeleteSchema>;
